(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wh-cone-split-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-cone-split-preview')) {
  customElements.define('wh-cone-split-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.services = JSON.parse(this.querySelector('[data-service-variants]').textContent);
      this.quantityInput = this.querySelector('[data-quantity]');
      this.maxQuantity = this.dataset.stockLimited === 'true' ? Math.max(0, Number(this.dataset.stock)) : Infinity;
      this.available = this.dataset.available === 'true';
      this.money = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.weightFormat = new Intl.NumberFormat(this.dataset.locale || 'de', { maximumFractionDigits: 1 });
      this.querySelector('fieldset').disabled = false;
      this.quantityInput.disabled = false;
      this.addEventListener('change', () => { this.normalizeQuantity(); this.update(); });
      this.addEventListener('input', event => { if (event.target === this.quantityInput) this.update(); });
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-step]');
        if (step && !this.busy) {
          this.quantityInput.value = this.quantity() + Number(step.dataset.step);
          this.normalizeQuantity();
          this.update();
        }
        if (event.target.closest('[data-add]')) this.addToCart();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target === this.quantityInput) {
          event.preventDefault();
          this.addToCart();
        }
      });
      this.update();
    }
    parts() {
      const value = Number(this.querySelector('input[type="radio"]:checked')?.value || 0);
      return [2, 3, 4, 5].includes(value) ? value : 0;
    }
    quantity() {
      return Math.min(Math.max(1, this.maxQuantity), Math.max(1, Math.floor(Number(this.quantityInput.value)) || 1));
    }
    normalizeQuantity() { this.quantityInput.value = this.quantity(); }
    isValid() {
      const value = Number(this.quantityInput.value);
      const service = this.services[this.parts()];
      return this.available && Number.isInteger(value) && value >= 1 && value <= this.maxQuantity && (!this.parts() || service?.available);
    }
    update() {
      const parts = this.parts();
      const quantity = this.quantity();
      const service = this.services[parts];
      const valid = this.isValid();
      this.querySelector('[data-add]').disabled = !!this.busy || !valid;
      this.querySelector('[data-add]').textContent = this.busy ? this.messages.adding : this.available ? this.messages.add : this.messages.sold_out;
      this.querySelector('fieldset').disabled = !!this.busy;
      this.quantityInput.disabled = !!this.busy;
      this.quantityInput.setAttribute('aria-invalid', String(!valid && this.available));
      this.quantityInput.setCustomValidity(valid || !this.available ? '' : this.messages.invalid);
      this.querySelector('[data-step="-1"]').disabled = !!this.busy || quantity <= 1;
      this.querySelector('[data-step="1"]').disabled = !!this.busy || quantity >= this.maxQuantity || !this.available;
      this.querySelectorAll('input[type="radio"]').forEach(input => {
        input.disabled = Number(input.value) > 0 && !this.services[input.value]?.available;
      });
      const fee = parts && service ? Number(service.price) * quantity : 0;
      const yarn = Number(this.dataset.price) * quantity;
      this.total = yarn + fee;
      this.querySelector('[data-yarn]').textContent = this.money.format(yarn / 100);
      this.querySelector('[data-fee]').textContent = this.money.format(fee / 100);
      this.querySelector('[data-total]').textContent = this.money.format(this.total / 100);
      const wholeWeight = this.weightFormat.format(Number(this.dataset.weight));
      const portionWeight = this.weightFormat.format(Number(this.dataset.weight) / (parts || 1));
      this.querySelector('[data-original]').textContent = wholeWeight;
      this.querySelector('[data-result]').textContent = parts ? this.messages.split.replace('[count]', parts).replace('[weight]', portionWeight) : this.messages.unsplit.replace('[weight]', wholeWeight);
      this.querySelectorAll('.wh-cone-picture').forEach((cone, index) => cone.toggleAttribute('hidden', index >= (parts || 1)));
      this.querySelectorAll('[data-portion]').forEach(portion => { portion.textContent = this.messages.portion.replace('[weight]', portionWeight); });
      const multiple = this.querySelector('[data-multiple]');
      multiple.hidden = !(parts && quantity > 1);
      multiple.textContent = this.messages.multiple.replace('[quantity]', quantity).replace('[parts]', parts).replace('[total]', quantity * parts);
      if (!this.busy) this.querySelector('[data-status]').hidden = true;
    }
    async readCart() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(this.messages.error);
      return response.json();
    }
    async postCart(endpoint, body) {
      const response = await fetch(`${window.Shopify.routes.root}cart/${endpoint}.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.messages.error);
      return data;
    }
    bundleMatches(cart, group, quantity, serviceId) {
      const items = cart.items.filter(item => item.properties?._wh_spul_group === group);
      const parent = items.find(item => item.properties?._wh_spul_role !== 'service');
      const child = items.find(item => item.properties?._wh_spul_role === 'service');
      return items.length === 2 && parent?.variant_id === Number(this.dataset.variantId) && parent.quantity === quantity && child?.variant_id === Number(serviceId) && child.quantity === quantity && child.parent_relationship?.parent_key === parent.key;
    }
    async removeAttempt(group) {
      for (let attempt = 0; attempt < 4; attempt += 1) {
        const cart = await this.readCart();
        const items = cart.items.filter(item => item.properties?._wh_spul_group === group);
        if (!items.length) return;
        const item = items.find(line => line.properties?._wh_spul_role !== 'service') || items[0];
        await this.postCart('change', { id: item.key, quantity: 0 });
      }
      if ((await this.readCart()).items.some(item => item.properties?._wh_spul_group === group)) throw new Error(this.messages.review_cart);
    }
    formProperties() {
      const properties = {};
      const form = this.closest('form');
      if (form) {
        for (const [key, value] of new FormData(form).entries()) {
          const match = key.match(/^properties\[([^\]]+)\]$/);
          if (match && typeof value === 'string' && value.trim()) properties[match[1]] = value;
        }
      }
      return properties;
    }
    async addBundle(parts, quantity) {
      const variantId = Number(this.dataset.variantId);
      const properties = this.formProperties();
      if (!parts) {
        await this.postCart('add', { items: [{ id: variantId, quantity, properties }] });
        return this.readCart();
      }
      const service = this.services[parts];
      const group = crypto.randomUUID();
      const weight = this.weightFormat.format(Number(this.dataset.weight) / parts);
      properties._wh_spul_group = group;
      properties._wh_spul_parts = String(parts);
      properties._wh_spul_service_variant = String(service.id);
      properties[this.messages.property_service] = this.messages.property_selection.replace('[count]', parts);
      properties[this.messages.property_weight] = this.messages.property_portion.replace('[weight]', weight);
      try {
        await this.postCart('add', { items: [{ id: variantId, quantity, properties }] });
        const afterParent = await this.readCart();
        const parent = afterParent.items.find(item => item.properties?._wh_spul_group === group && item.properties?._wh_spul_role !== 'service');
        if (!parent || parent.quantity !== quantity) throw new Error(this.messages.error);
        await this.postCart('add', { items: [{ id: Number(service.id), quantity, parent_line_key: parent.key, properties: { _wh_spul_group: group, _wh_spul_role: 'service' } }] });
        const cart = await this.readCart();
        if (!this.bundleMatches(cart, group, quantity, service.id)) throw new Error(this.messages.error);
        return cart;
      } catch (error) {
        const cart = await this.readCart();
        if (this.bundleMatches(cart, group, quantity, service.id)) return cart;
        await this.removeAttempt(group);
        throw error;
      }
    }
    async addToCart() {
      if (this.busy || !this.isValid()) return;
      const parts = this.parts();
      const quantity = Number(this.quantityInput.value);
      this.busy = true;
      this.update();
      let message = '';
      let error = false;
      try {
        if (!window.WhSpulserviceCart?.run) throw new Error(this.messages.error);
        await window.WhSpulserviceCart.run(() => this.addBundle(parts, quantity));
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer?.open) drawer.open(this.querySelector('[data-add]'));
        else window.location.assign(`${window.Shopify.routes.root}cart`);
        message = this.messages.added;
      } catch (failure) {
        error = true;
        message = failure instanceof TypeError ? this.messages.error : failure.message || this.messages.error;
      } finally {
        this.busy = false;
        this.update();
        const status = this.querySelector('[data-status]');
        status.textContent = message;
        status.dataset.error = String(error);
        status.setAttribute('role', error ? 'alert' : 'status');
        status.hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-new-colors-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-new-colors-badge')) {
    class WhNewColorsBadge extends HTMLElement {
      constructor() {
        super();
        this.checkExpiry = this.checkExpiry.bind(this);
      }

      connectedCallback() {
        window.addEventListener('pageshow', this.checkExpiry);
        document.addEventListener('visibilitychange', this.checkExpiry);
        this.checkExpiry();
      }

      disconnectedCallback() {
        window.clearTimeout(this.expiryTimer);
        window.removeEventListener('pageshow', this.checkExpiry);
        document.removeEventListener('visibilitychange', this.checkExpiry);
      }

      checkExpiry() {
        window.clearTimeout(this.expiryTimer);

        const expiresAt = Number(this.getAttribute('data-expires'));
        const remaining = expiresAt * 1000 - Date.now();
        this.hidden = !Number.isSafeInteger(expiresAt) || expiresAt <= 0 || remaining <= 0;

        if (!this.hidden) {
          this.expiryTimer = window.setTimeout(this.checkExpiry, Math.min(remaining, 2147483647));
        }
      }
    }

    customElements.define('wh-new-colors-badge', WhNewColorsBadge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-variant-new-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-variant-new-colors')) {
    const berlinClock = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const endOfBerlinDate = (value) => {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return 0;
      const [year, month, day] = value.split('-').map(Number);
      if (year < 1000) return 0;
      const date = new Date(Date.UTC(year, month - 1, day));
      if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return 0;
      const wallMidnight = Date.UTC(year, month - 1, day + 1);
      let instant = wallMidnight;
      for (let pass = 0; pass < 3; pass += 1) {
        const parts = {};
        berlinClock.formatToParts(instant).forEach(({ type, value: part }) => {
          if (type !== 'literal') parts[type] = Number(part);
        });
        const wallTime = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
        instant += wallMidnight - wallTime;
      }
      return instant;
    };

    class WhVariantNewColors extends HTMLElement {
      connectedCallback() {
        this.picker = this.closest('variant-picker');
        if (!this.picker) return;
        this.selectedVariantId = this.dataset.selectedVariant || '';
        this.expiries = new Map();
        this.onVariantChange = (event) => {
          if (event.target !== this.picker) return;
          this.selectedVariantId = event.detail.variant ? String(event.detail.variant.id) : '';
          this.refresh();
        };
        this.onResume = () => this.refresh();
        this.picker.addEventListener('on:variant:change', this.onVariantChange);
        document.addEventListener('visibilitychange', this.onResume);
        window.addEventListener('pageshow', this.onResume);
        window.addEventListener('focus', this.onResume);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          this.querySelectorAll('[data-variant-id][data-until]').forEach((entry) => {
            this.expiries.set(entry.dataset.variantId, endOfBerlinDate(entry.dataset.until));
          });
          this.refresh();
        });
        customElements.whenDefined('variant-picker').then(() => {
          if (!this.isConnected || !this.picker.hasAttribute('loaded')) return;
          this.selectedVariantId = this.picker.variant ? String(this.picker.variant.id) : '';
          this.refresh();
        });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.frame);
        this.picker?.removeEventListener('on:variant:change', this.onVariantChange);
        document.removeEventListener('visibilitychange', this.onResume);
        window.removeEventListener('pageshow', this.onResume);
        window.removeEventListener('focus', this.onResume);
      }

      refresh() {
        clearTimeout(this.timer);
        if (!this.isConnected || !this.picker) return;
        const now = Date.now();
        this.picker.querySelectorAll('.wh-variant-new-badge').forEach((badge) => {
          badge.hidden = !(this.expiries.get(badge.dataset.variantId) > now);
        });
        const selectedIsNew = this.expiries.get(this.selectedVariantId) > now;
        this.picker.querySelectorAll('.wh-variant-new-selected').forEach((label) => {
          label.hidden = !selectedIsNew;
        });
        const future = [...this.expiries.values()].filter((expiry) => expiry > now);
        if (future.length) {
          this.timer = setTimeout(() => this.refresh(), Math.min(Math.min(...future) - now, 2147483647));
        }
      }
    }

    customElements.define('wh-variant-new-colors', WhVariantNewColors);
  }
  } catch(e) { console.error(e); }
})();

})();
